<template>
  <v-container class="registryservices">
    <PageHeader title="Manage Services" icon="settings" subtitle="Manage services and configurations, and view execution logs." />

    <ServiceLinks class="mb-4" :services="services" :isLoaded="fetchedServices" />
    <ServiceRefreshTokens class="mb-4" />

    <Subheader v-model="searchText" title="Services" search="services">
      <RegisterServiceDialog />
      <InstallServicesDialog />
      <v-btn class="register-service-btn" color="warning" @click.native="getServices()">
        <v-icon left>refresh</v-icon>
        Refresh Service
      </v-btn>
    </Subheader>

    <v-layout v-if="isLoading" style="padding-top: 150px;">
      <PageLoader resourceName="Services" />
    </v-layout>
    <template v-else>
      <v-layout row-wrap>
        <template>
          <v-tabs dark grow centered style="width: 100%;">
            <v-tab v-for="(serviceGrouping, index) in serviceGroupings" :key="index" @click="setCurrentTab(index)">
              <v-icon left>{{ serviceGrouping.icon }}</v-icon>
              {{ serviceGrouping.name }}
            </v-tab>

            <v-tab-item v-for="(serviceGrouping, index) in serviceGroupings" :key="`tabs-${index}`">
              <component :is="serviceGrouping.component" v-if="currentTab == index" :services="filteredServices" />
            </v-tab-item>
          </v-tabs>
        </template>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const Services = createNamespacedHelpers('services')

  import RegisterServiceDialog from './Actions/RegisterServiceDialog'
  import InstallServicesDialog from './Actions/InstallServicesDialog'
  import ServiceItem from './ServiceItem'

  import GroupByAll from './ServiceGrouping/GroupByAll'
  import GroupByActive from './ServiceGrouping/GroupByActive'

  import {
    filterMixin,
  } from '../Helpers/Filter'
  import ServiceLinks from './ServiceLinks'
  import ServiceRefreshTokens from './ServiceRefreshTokens'

  export default {
    components: {
      RegisterServiceDialog,
      InstallServicesDialog,
      ServiceItem,
      GroupByAll,
      GroupByActive,
      ServiceLinks,
      ServiceRefreshTokens,
    },
    mixins: [filterMixin],
    data() {
      return {
        fetchedServices: false,
        navItems: [{
          text: 'Manage Services',
          disabled: true,
        }],
        isLoading: true,
        currentTab: 0,
        serviceGroupings: [{
          name: 'Group by active',
          component: 'GroupByActive',
          icon: 'power',
        },
        {
          name: 'All',
          component: 'GroupByAll',
          icon: '',
        },
        ],
        searchText: '',
      }
    },
    computed: {
      ...Services.mapGetters(['services']),
      serviceValues() {
        return this.services.map(s =>
          this.getObjectValues(s)
        )
      },
      filteredServices() {
        return this.filterList(this.services, this.searchText)
      },
    },
    methods: {
      setCurrentTab(value) {
        if (this.currentTab != value) {
          this.currentTab = value
        }
      },
      setLoading(value) {
        this.isLoading = value
      },
      getServices() {
        this.setLoading(true)
        this.$store.dispatch('services/getServices')
          .then(function() {
            this.setLoading(false)
            this.fetchedServices = true
          }.bind(this))
          .catch(function() {
            this.setLoading(false)
          }.bind(this))
      },
      getFileExportnames() {
        this.$store.dispatch('uiconfig/getFileExportNames')
      },
    },
    created() {
      if(this.services == null || this.services.length === 0) {        
        this.getServices()
      } else {        
        this.setLoading(false)
        this.fetchedServices = true
      }
      this.getFileExportnames()
    },
  }
</script>

<style>
  @media only screen and (max-width: 519px) {
    .registryservices .register-service-btn {
      width: 100%;
      margin: 0px;
    }
  }

  .visibilityHidden {
    visibility: hidden;
  }

  .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>